export default __webpack_public_path__ + "static/media/arrow-head.f9f9124a.svg";